export enum ComponentHeights {
    AuthenticatedHeader = 68,
    AlertSmall = 56,
    AlertMedium = 69,
    PatientDetailsControl = 75,
    SegmentedControl = 53,
    ActionsFooter = 101,
    ConsultFilters = 62,
    // ACA-155: History's filter bar also holds the 36px search box
    ConsultFiltersWithSearch = 68,
    // ACA-156: version / created / rating strip below the consult tabs
    ConsultDetailsStrip = 52,
    AudioPlayer = 106,
    AdminTabs = 56,
    // ACA-175: processing banner in the consult view while a consult is created
    ConsultProcessingBanner = 64,
}
